import React from 'react';
import { Link } from '@mui/material';
import BaseFaq from 'components/Faq';
import { makeStyles } from '@mui/styles';
import { getEnv } from 'utils';

const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: 'underline',
    color: '#212121',
  },
}));

export default function Faq() {
  const classes = useStyles();

  return (
    <BaseFaq
      items={[
        {
          question: 'How long does the Season Break Campaign last?',
          answer: 'The Season Break campaign goes from June 15th until July 31st.',
        },
        {
          question: 'What is a 3-month Researcher Subscription?',
          answer:
            "The 3-month researcher subscription is a plan in which you can enjoy all Mind the Graph's premium benefits for 3 months. The 3 month subscription is paid quarterly (once in three months) on your credit card, and after the billing, you can use the tool freely for the next 3 months.",
        },
        {
          question: 'How does the 3-month subscription work?',
          answer: (
            <>
              After confirming your payment details, the special price of 29 USD will be charged to
              your credit card. Then you can enjoy Mind the Graph's benefits for the next 3 months.
              After the first 3 months, <b>the subscription will be automatically renewed</b> to 3
              more months and you will be charged the regular price of 36 USD.
            </>
          ),
        },
        {
          question: 'What payment method can I use to subscribe?',
          answer: 'You can subscribe using your credit card.',
        },
        {
          question: "Who can enjoy Mind the Graph's Season Break offer?",
          answer: [
            <>
              This special offer is available only for new users. If you are already a subscriber,
              you can make your upgrade using our regular{' '}
              <Link
                className={classes.link}
                href={`${getEnv('MTG_URL_APP')}/pricing`}
                target="_blank"
                underline="hover"
              >
                pricing page
              </Link>
              .
            </>,
          ],
        },
        {
          question: 'Can I cancel my subscription?',
          answer: (
            <>
              Yes. You can cancel your subscription anytime. Just{' '}
              <Link
                className={classes.link}
                href={`${getEnv('MTG_URL_APP')}/blog/faq/how-do-i-cancel-my-subscription`}
                target="_blank"
                underline="hover"
              >
                follow these instructions
              </Link>{' '}
              or reach us through <span className={classes.link}>contact@mindthegraph.com</span> in
              case you have any problem.
            </>
          ),
        },
        {
          question: 'Can I get a discount after the 3 months subscription period ends?',
          answer: (
            <>
              Yes. You can get up to a 100% discount on your subscriptions fees for the following
              month by joining our{' '}
              <Link
                className={classes.link}
                href={`${getEnv('MTG_URL_APP')}/friends-referral`}
                target="_blank"
                underline="hover"
              >
                friends referral program
              </Link>
              . You can also <b>save 52% of your investment</b> by upgrading your subscription to an
              annual plan. That's 12 months for the price of 8 + 60 custom illustrations created by
              request per year.
            </>
          ),
        },
        {
          question: 'Is Mind the Graph a trustworthy company?',
          answer: (
            <>
              We are humans just like you, don't hesitate to meet our values and team members on a
              special page we made for you to get to know us better, the{' '}
              <Link
                className={classes.link}
                href={`${getEnv('MTG_URL_APP')}/about-us`}
                target="_blank"
                underline="hover"
              >
                About Us
              </Link>{' '}
              page. Also, we gather all our feedbacks and nourish automatically this really cool
              mural where you can{' '}
              <Link
                className={classes.link}
                href={`${getEnv('MTG_URL_APP')}/feedbacks`}
                target="_blank"
                underline="hover"
              >
                check what every user is talking about us
              </Link>
              . At last, we are a{' '}
              <Link
                className={classes.link}
                href="https://cactusglobal.com/brands/"
                target="_blank"
                underline="hover"
              >
                Cactus Communications (CACTUS)
              </Link>{' '}
              brand, a technology company accelerating scientific advancement with over 2,500
              experts working for more than 874,000 clients in 191 countries that has 8 different
              products so far to help scientists perform at their best.
            </>
          ),
        },
        {
          question: 'What happens after the 3 Months subscription ends?',
          answer:
            'After the first 3 months, the subscription will be automatically renewed to 3 more months and you will be charged the regular price of 36 USD.',
        },
      ]}
    />
  );
}
